import { IconProps } from '../../Interfaces/Props'

const IconLogout2 = (props: IconProps) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={props.size?? '22'} height={props.size?? '22'} className={props.className} viewBox="0 0 24 24">
            <path d="M0 0h24v24H0z" fill="none" />
            <g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5">
                <path d="M15 17.499c0 .93 0 1.395-.102 1.777a3 3 0 0 1-2.121 2.12c-.382.103-.847.103-1.777.103H9c-2.828 0-4.243 0-5.121-.879C3 19.742 3 18.327 3 15.5V8.501c0-2.828 0-4.242.879-5.12c.878-.88 2.292-.88 5.12-.88h2.003c.928 0 1.392 0 1.773.102a3 3 0 0 1 2.123 2.123c.102.38.102.845.102 1.773m0 13.002c2.828 0 4.243 0 5.121-.879c.879-.878.879-2.293.879-5.121v-3c0-2.828 0-4.243-.879-5.121c-.878-.88-2.293-.88-5.121-.88" />
                <path d="M16 12.001H9m5.5-2.5s2.5 1.841 2.5 2.5s-2.5 2.5-2.5 2.5" />
            </g>
        </svg>
    )
}

export default IconLogout2